import { useEffect } from "react";
import AppProviders from "./providers/AppProviders";
import AppRouter from "./router/AppRouter";
import { requestUserLocationOnEntry } from "../shared/location/userLocation";
import "../shared/styles/theme.css";
import "../shared/styles/app.css";
import "react-datepicker/dist/react-datepicker.css";

export default function App() {
  useEffect(() => {
    requestUserLocationOnEntry();
  }, []);

  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
